import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { USER_ROLES } from 'src/app/config/user-roles';
import { AuthService } from 'src/app/services/auth.service';
import { PermissionService } from 'src/app/services/permission.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const permissionService = inject(PermissionService);

  if (!authService.isLoggedIn()) {
    router.navigateByUrl('/auth');
    return false;
  }

  if (authService.isOnboardingRequired()) {
    router.navigateByUrl('/auth/onboarding');
    return false;
  }

  const permission = route.data['perm'];

  const isAllowed = Array.isArray(permission) ? permissionService.hasAny(permission) : permissionService.has(permission);

  if (isAllowed) return true;

  if (authService.is(USER_ROLES.INSTRUCTOR)) {
    router.navigate(['/instructor/dashboard'])
  } else {
    router.navigate(['/profile', authService.userSig()?.id ?? 'no-user'])
  }
  return false;

};